import React from "react";

const StopBoardModal = ({ onDismiss, onSave, onStop }) => {
  return (
    <div>
      Your drawing will be lost if you don’t save it.
      <br />
      <br />
      <div className="stop-board-modal-content">
        <button onClick={onSave} className="confirm-button business-button">
          Save First...
        </button>
        <button
          onClick={onStop}
          className="confirm-button delete-bg-color w-50"
        >
          Stop
        </button>
      </div>
    </div>
  );
};

export default StopBoardModal;
